<div class="table-scroll">
  <p-table [value]="orders" sortField="id" sortOrder="-1" [paginator]="false" styleClass="p-datatable-sm"
    [totalRecords]="totalRecords" [showCurrentPageReport]="true"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [rows]="10" dataKey="id">
    <ng-template pTemplate="caption">
      <div class="table-header">
        Meus Pedidos
      </div>
    </ng-template>

    <ng-template pTemplate="header">
      <tr *ngIf="!loading">
        <th style="width: 3rem"></th>
        <th pSortableColumn="inclusionDate">Data<p-sortIcon field="inclusionDate"></p-sortIcon>
        </th>
        <th pSortableColumn="totalValue">Total<p-sortIcon field="totalValue"></p-sortIcon>
        </th>
        <th pSortableColumn="orderItems.length">Quantidade de Itens<p-sortIcon field="orderItems.length"></p-sortIcon>
        </th>
        <th pSortableColumn="itemsCount">Quantidade de Produtos<p-sortIcon field="itemsCount"></p-sortIcon>
        </th>
        <th pSortableColumn="orderNumber">Nº Pedido Gestão<p-sortIcon field="orderNumber"></p-sortIcon>
        </th>
        <th pSortableColumn="id">Nº Pedido Plataforma<p-sortIcon field="id"></p-sortIcon>
        </th>
        <!-- <th></th> -->
        <th></th>
        <th>Documentos</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">

      <div class="col" style="text-align: center;">
        <div *ngIf="loading">
          <div><p-progressSpinner></p-progressSpinner></div>
          <div>Carregando dados...</div>
        </div>
      </div>
      <tr *ngIf="!loading" class="col" style="text-align: center;">
        <td [attr.colspan]="9">Nenhum pedido encontrado</td>
      </tr>

    </ng-template>

    <!--<ng-template pTemplate="emptymessage" let-columns>
      <tr  class="justify-content-center">
          <td [attr.colspan]="columns.length" style="align-content: center;">
              No records found
          </td>
      </tr>
  </ng-template> -->
    <ng-template pTemplate="body" let-order let-expanded="expanded">
      <tr>
        <td>
          <button type="button" pButton pRipple [pRowToggler]="order"
            class="p-button-text p-button-rounded p-button-plain"
            [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></button>
        </td>
        <td>{{ order.inclusionDate | date:'short' }}</td>
        <td>{{ order.totalValue | currency:'BRL' }}</td>
        <td>{{ order.items.length | number: '2.0-0' }}</td>
        <td>{{ order.itemsCount | number: '2.0-0' }}</td>
        <td>{{ order.orderNumber | number: '2.0-0' }}</td>
        <td *ngIf="order.orderSituation != 'SALVO_CONTINUAR_COMPRANDO'">{{ order.id | number: '2.0-0' }}</td>
        <!-- <td *ngIf="order.orderSituation == 'SALVO_CONTINUAR_COMPRANDO'"></td> -->
        <td *ngIf="order.orderSituation != 'SALVO_CONTINUAR_COMPRANDO'">
          <button disabled="true" pButton pRipple type="button"
            class="p-button-rounded p-button-raised p-button-text btn-conclude">
            CONCLUÍDO
          </button>
        </td>
        <td>
          <p-progressBar *ngIf="downloadingDocument && selectedOrderId == order.id" mode="indeterminate"
            [style]="{'height': '6px'}">
          </p-progressBar>
          <button type="button" [disabled]="downloadingDocument"
            *ngIf="!(downloadingDocument && selectedOrderId == order.id)" pButton icon="pi pi-bars"
            class="p-button-raised menu-document-btn"
            (click)="selectedOrderId = order.id;menu.toggle($event)"></button>
          <p-menu #menu [popup]="true" [model]="documents" appendTo="body"></p-menu>
        </td>
        <!-- <td *ngIf="order.orderSituation != 'SALVO_CONTINUAR_COMPRANDO'"></td>
        <td *ngIf="order.orderSituation == 'SALVO_CONTINUAR_COMPRANDO'">
          <button pButton pRipple type="button" class="p-button-rounded p-button-raised p-button-text btn-continue"
            (click)="keepBuying(order)">
            CONTINUAR COMPRANDO<i class="pi pi-shopping-cart p-pl-3"></i>
          </button>
        </td>
        <td *ngIf="order.orderSituation == 'SALVO_CONTINUAR_COMPRANDO'">
          <button pButton pRipple type="button" class="p-button-rounded p-button-raised p-button-text btn-end-order"
            (click)="postOrder(order)">
            FINALIZAR PEDIDO
          </button>
        </td> -->

      </tr>
    </ng-template>
    <ng-template pTemplate="rowexpansion" let-orders>
      <tr>
        <td colspan="8">
          <div class="p-p-3">
            <p-table [value]="orders.items" dataKey="id">
              <ng-template pTemplate="header">
      <tr>
        <th class="th">Produtos</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-item>
      <tr>
        <td class="td row">

          <div class="col-xl-4 title">{{ getProductName(item) | titlecase }}</div>
          <div class="col-md-4 value">{{ item.quantity | number: '2.0-0'}} {{ item.measurementUnitInitials }} x
            {{ (item.price * item.measurementUnitQuantity) | currency:'BRL' }} = {{ item.totalValue | currency:'BRL' }}
          </div>
          <!-- <div class="col-md-2 total">{{  | currency:'BRL' }}</div> -->
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
</td>
</tr>
</ng-template>
</p-table>
<p-paginator [rows]="15" [totalRecords]="totalRecords" (onPageChange)="reloadData($event)"></p-paginator>
</div>
